/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $DepartmentSchedulePPD = {
    type: 'all-of',
    contains: [{
    type: 'PPDDetail',
}, {
    properties: {
        department_id: {
    type: 'number',
    isRequired: true,
},
        department_name: {
    type: 'string',
    isRequired: true,
},
        titles: {
    type: 'array',
    contains: {
        type: 'TitleSchedulePPD',
    },
    isRequired: true,
},
    },
}],
};